import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'

import DestinationDesktopPage from './destination'

const DestinationDesktopContainer = ({ domainCountry }: { domainCountry: string }) => {
    return (
        <ErrorBoundaryWrapper identifier="destination-desktop">
            <DestinationDesktopPage domainCountry={domainCountry} />
        </ErrorBoundaryWrapper>
    )
}

export default DestinationDesktopContainer
